var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeAppTileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "51px",
    viewBox: "50 33 51 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / home_app_tile_active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "13.8250613%",
    y2: "11.9561887%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666",
    offset: "99.7432255%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8",
    stopOpacity: 0.14996722,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-home_app_tile_active",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "url(#linearGradient-1)",
    stroke: "url(#linearGradient-2)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICN-Home"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5,34.4020895 L100,58.4801799 L100,83 L51,83 L51,58.4801799 L75.5,34.4020895 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAppTileActive);
export default __webpack_public_path__ + "static/media/home_app_tile_active.605302fab50df96fc3aaa034116e4d8e.svg";
export { ForwardRef as ReactComponent };